<!-- 动态路由公共组件 -->
<template>
  <el-container class="layout">
    <el-header class="layout_header">
      <img src="../../assets/logo1.jpg" style="width:534px;height:48px;">
      <!-- <div class="logo_titles">现代制造的混凝土管片智慧工厂</div> -->
      <div style="display: flex; align-items: center; position:absolute;right:10px;">
        <div class="secrecy_tips">保密提示：严禁通过互联网传输、处理涉密文件和信息</div>
        <div class="header_close">
          <el-dropdown @command="quitSystem">
            <span class="el-dropdown-link">
              <i class="el-icon-user"></i> 
              {{realName}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="password">
                <i class="el-icon-key"></i>
                修改密码
              </el-dropdown-item>
              <el-dropdown-item command="logout">
                <i class="el-icon-switch-button"></i>
                退出登录
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </el-header>
    <el-container style="overflow: hidden;">
      <el-aside class="layout_sider" width="230px">
        <layout-aside></layout-aside>
      </el-aside>
      <el-main class="layout_content">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <!-- <template v-for="item in routerList">
            <el-breadcrumb-item :key="item.meta.menuId">{{item.meta.title}}</el-breadcrumb-item>
          </template> -->
        </el-breadcrumb>
        <transition>
          <router-view />
        </transition>
      </el-main>
    </el-container>
    <!-- 修改密码 -->
    <el-dialog
      class="prop_dialog"
      :close-on-click-modal="false"
      title="修改密码"
      :visible.sync="asyncPassword"
      width="35%">
      <el-form ref="form" :model="ruleForm" :rules="rules" label-width="auto" class="rule_form">
        <el-form-item label="旧密码：" prop="oldPassword">
          <el-input v-model="ruleForm.oldPassword" type="password" clearable placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="password">
          <el-input v-model="ruleForm.password" type="password" clearable placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码：" prop="tpassword">
          <el-input v-model="ruleForm.tpassword" type="password" clearable placeholder="请再次输入新密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncPassword = false">取 消</el-button>
        <el-button class="submit_btn" @click="updatePawssword"> 提 交</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import { changeSize } from "../../plugins/public";
import LayoutAside from './components/LayoutAside.vue'; // 导航菜单组件
export default {
  components: {
    LayoutAside
  },
  data() {
     const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        // if (this.ruleForm.oldPassword !== '') {
        //   this.$refs.form.validateField('oldPassword');
        // }
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      const regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,30}$/;
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else if(!regex.test(value)) {
        callback(new Error('新密码应由：长度8-30位，并且至少由1个数字、1个大写字母、1个小写字母等组成'));
      } else {
        callback();
      }
    };
    const validatePass3 = (rule, value, callback) => {
      if (value !==this.ruleForm.password) {
        callback(new Error('两次输入的密码不一致！！！'));
      }else {
        callback();
      }
    };
    return {
      size: changeSize(),
      realName:sessionStorage.getItem('realName'),
      asyncPassword: false, // 修改密码
       ruleForm: {}, // 修改密码表单
      rules: {
        oldPassword: [{
          required: true, 
          validator: validatePass, 
          trigger: 'blur' 
        }],
        password: [{ 
          required: true,
          validator: validatePass2, 
          trigger: 'blur' 
        }],
        tpassword: [{ 
          required: true,
          validator: validatePass3, 
          trigger: 'blur' 
        }],
      }, // 表单验证
      routerList: [], // 路由信息
      closeNotify:null,
      timer:null,//定时器
      alarmList:[
      ],//报警信息组
    };
  },
  mounted() {
    this.routerList = this.$route.matched.map(item => {
      return {
        path: item.path,
        meta: item.meta
      }
    });
    this.timer = setInterval(()=>{
      this.getAlarmDatas()
    }, 60000)
  },
  methods: {
    // 退出登录
    quitSystem(val) {
      if(val === 'logout'){
        this.$confirm("您要退出本系统，是否继续？","提示", {
          confirmButtonText: "确定",
          cancelButtonTexy: "取消",
          type: "warning"
        }).then(() => {
          this.$api.System.logingOut({}).then(res => {
            if(res.statusMsg === 'ok') {
              sessionStorage.clear();
              this.$router.replace('/login');
              this.$message.success('退出成功！');
            }
          })
        })
        .catch(() => {
          this.$message.info('您已取消！');
        })
      }else{
        this.asyncPassword = true
      }
    },
    // 提交修改密码
    updatePawssword() {
      this.$refs.form.validate(valid => {
        if(valid) {
            let params = {
              oldPass:this.ruleForm.oldPassword,
              newPass:this.ruleForm.password
            }
            this.$api.System.updatePasswordInfo(params).then((res) => {
              if (res?.statusMsg === 'ok') {
                this.asyncPassword = false;
                this.$message.success('修改成功！')
                this.$router.replace('/login');
              } else {
                this.$message.warning(res?.statusMsg);
              }
            })
        }
      })
    },
    //展示报警信息
    showAlarmTips(){
      const h = this.$createElement
      this.alarmList.forEach((item)=>{
        this.closeNotify =window.setTimeout(()=>{
            this.$notify({
              position: 'bottom-right',
              showClose:true,
              duration:5000,
              dangerouslyUseHTMLString: true,
              message:h("div",{class:"alarm_tips"},[
                h("div",{class:"alarm_tip_header"},[
                  h("div",{class:"alarm_tip_text"},'钢筋预警'),
                ]),
                h("div",{class:"alarm_tip_content"},[
                  h("div",{class:'alarm_tip_content_text'},`${item.steelName}`),
                  h("div",{class:"alarm_tip_content_datas"},'已低于预警库存')
                ]),
              ])
            });
        },0)
      })
    },
    //获取报警数据 
      getAlarmDatas(){
        this.$api.Rebar.alarmTipsBear({}).then(res=>{
        if(res.statusMsg =='ok'){
          this.alarmList = res.data
          this.showAlarmTips()
        }else{
          this.$message.warning(res.statusMsg)
        }
      })
    },
  },
  watch: {
    $route() {
      this.routerList = this.$route.matched.map(item => {
        return {
          path: item.path,
          meta: item.meta
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../style/layout-main.scss';
.layout {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: linear-gradient(
    150deg,
  rgba(17, 55, 97, 1) 8%,
  rgba(10, 33, 66, 1) 92%);

  .layout_header {
    position: relative;
    display: flex;
    align-items: center;
    color: #fff;
    background: transparent;
    .logo_titles{
      color: #39B5FE;
      font-size: 24px;
      font-weight: 900;
      font-family:"Microsoft YaHei";
      -webkit-text-stroke: 0.2px #ffffff;
    }
    img{
      margin-right: 10px;
    }

    .header_close {
      // position: absolute;
      // top: 50%;
      // right: 2%;
      // transform: translateY(-50%);
    }
    .secrecy_tips{
      // position: absolute;
      // top: 50%;
      // right: 6%;
      // transform: translateY(-50%);
      color: red;
      font-size: 15px;
      font-weight: 500;
      margin-right: 10px;
    }
  }

  .layout_content {
    position: relative;
    padding: 20px 20px 0;
    background: url('../../assets/main_bg.jpg')no-repeat;
    background-size: 100% 100%;
    overflow: hidden;

    &::before {
      position: absolute;
      content: '';
      width: calc(100% - 30px);
      height: calc(100% - 15px);
      background: rgba($color: #040D1A, $alpha: .7);
    }

    /deep/ .el-breadcrumb__inner {
      color: #14C6CD;

      &:last-of-type {
        color: #18F5DB;
      }
    }
  }

  .layout_sider {
    margin: 0;
    height: 100%;
    border-right: none;
    background: transparent;
    overflow: hidden;
  }
}
/deep/.el-dropdown{
  color: #fff;
  cursor: pointer;
  &:hover{
    color: #39B5FE;
  }
}
::v-deep .el-input--small .el-input__inner{
  border:1px solid #39B5FE;
  background-color: transparent;
  color: #fff;
}

.alarm_tips{
  display: flex;
  flex-direction: column;
  position: relative;
  line-height: 45px;

  .alarm_tip_header{
    width: 100%;
    display: flex;
    justify-content: space-between;
    position: absolute;
    top: -20px;
    
    .alarm_tip_text{
      color:#fff;
      font-size: 16px;
      margin-left: 10px;
      padding-right:35px;
      position: relative;
      &::before{
        content: "";
        position: absolute;
        top: 14px;
        left: -20px;
        width: 15px;
        height: 15px;
        background: url("../../assets/alarm_icons.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .alarm_tip_time{
      color: #999;
    }
    .alarm_tip_close{
      color: #f42829;
      cursor: pointer;
    }
  }
  .alarm_tip_content{
    display: flex;
    padding-top: 5px;
    .alarm_tip_content_text{
      padding-top: 15px;
      color: #f42829;
    }
    .alarm_tip_content_datas{
      padding-left: 15px;
      padding-top: 15px;
      color: #fff;
    }
  }
}
</style>